import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Numeral from 'numeral';

import './styles.scss';
import AddCarImgField from '../addCarImgField';

import chekImg from './img/check.png';
import calendar from './img/Calendar.svg';

class addCarImg extends Component {
  constructor () {
    super();
    this.state = {
    };
  }
  render() {
    return (
      <div className="body-AddCarImg">
        <div className="title-AddCarImg">
          Uploading a car
        </div>
        <div className="previousDescription-AddCarImg">
          <span><img src={chekImg} alt="chek_img" /></span>
          <div>
            Description
          </div>
          <button onClick={this.props.CarChange}>
            CHANGE
          </button>
        </div>
        <div className="info-AddCarImg">
          <div className="rowConteiner-AddCarImg">
            <div>Type</div>
            <div>
              {this.props.carsData.build.body_type}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Manufacturer</div>
            <div>
              {this.props.carsData.build.make}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Model</div>
            <div>
              {this.props.carsData.build.model}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Production Year<img src={calendar} alt="calendar_pic" /></div>
            <div>
              {this.props.carsData.build.year}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Mileage</div>
            <div>
              {`${Numeral(this.props.carsData.miles).format('0,0')} km`}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Vehicle cost</div>
            <div>
              {Numeral(this.props.carsData.price).format('$ 0,0[.]00')}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Transmission</div>
            <div>
              {this.props.carsData.build.transmission}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Fuel type</div>
            <div>
              {this.props.carsData.build.fuel_type}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Exterior Color</div>
            <div>
              {this.props.carsData.exterior_color}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Interior Color</div>
            <div>
              {this.props.carsData.interior_color}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Doors</div>
            <div>
              {this.props.carsData.build.doors}
            </div>
          </div>
          <div className="rowConteiner-AddCarImg">
            <div>Seating</div>
            <div>
              {this.props.carsData.build.std_seating}
            </div>
          </div>
        </div>
        <div className="description-AddCarImg">
          <span>2</span>
          <div>
            Upload image(s)
          </div>
        </div>
        <AddCarImgField
          uploadImgHandl={this.props.uploadImgHandl}
          delImgHandl={this.props.delImgHandl}
        />
        <div className="uploadImg-AddCarImg">
          <button
            onClick={this.props.AddCarFinish}
            className={`button-AddCarImg -finishButton -${this.props.carsData.media.photo_links.length === 0} ? 'true' : ''}`}
            disabled={this.props.carsData.media.photo_links.length === 0}
          >FINISH
          </button>
          <button className="button-AddCarImg" onClick={this.props.closeAddCarPage} >CANCEL</button>
        </div>
      </div>
    );
  }
}

addCarImg.propTypes = {
  uploadImgHandl: PropTypes.func.isRequired,
  // imgLink: PropTypes.string.isRequired,
  AddCarFinish: PropTypes.func.isRequired,
  closeAddCarPage: PropTypes.func.isRequired,
  CarChange: PropTypes.func.isRequired,
  carsData: PropTypes.instanceOf(Object).isRequired,
  delImgHandl: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  carsData: state.careditor.pagesData.addCar.data
});

export default connect(mapStateToProps, null)(addCarImg);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/addCar/components/addCarImg/index.js